/**
 * GA4 測定ID（Firebase Console の Measurement ID と同一の G-XXXX 形式）
 */
export const GA_MEASUREMENT_ID = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

/** 測定IDが設定されている場合に GA を有効化 */
export const isAnalyticsEnabled = Boolean(GA_MEASUREMENT_ID);
